module.exports = __webpack_public_path__ + "static/media/ground-large.8e50880f.png";